export const SUCCESS_TIMER_THEME = 'SUCCESS_TIMER_THEME';
export const SESSION_ENDED_THEME = 'SESSION_ENDED_THEME';
export const WAITING_REPLY_TIMER_THEME = 'WAITING_REPLY_TIMER_THEME';



// WEBPACK FOOTER //
// ./src/scenes/Chat/services/constants/chatBannerThemes.js